import React, { Fragment } from "react";
import "./deserve.scss";
import { LazyLoadImage } from "react-lazy-load-image-component";
import ClaimButton from "../ClaimButton";
import comRight from "../../assests/images/deserve-right.png";
import TrustPilot from "../../assests/images/trustpilot-white.svg";

const Deserve = () => {
  return (
    <Fragment>
      <div className="deserve">
        <div className="container1500">
          <div className="deserve-left">
            <h2>
              <span>Claim The</span> Compensation you Deserve
            </h2>
            <p className="desc">
              If you have suffered because of personal injury, we're here to
              help and match you with the solicitors we work with.
            </p>
            <ClaimButton />
            <div className="banner__details-rating deservestarRating">
              <span>
                <strong>Excellent</strong>
              </span>
              <span>
                <img
                  src="https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-4.5.svg"
                  alt=""
                  width={96}
                  height={21}
                />
              </span>
              <span>
                <strong>1,378+</strong> Reviews On
              </span>
              <span>
                <img src={TrustPilot} alt="" />
              </span>
            </div>
          </div>
          <div className="deserve-right">
            <LazyLoadImage
              className="comRightImg"
              src={comRight}
              alt="deserve"
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Deserve;
